// Cart Success Message Functionality
function showCartSuccessMessage() {
  // Remove any existing success message
  const existingMessage = document.querySelector('.cart-success-message');
  if (existingMessage) {
    existingMessage.remove();
  }

  // Create the success message element
  const successMessage = document.createElement('div');
  successMessage.className = 'cart-success-message';
  
  // Use the German translation directly since we know it exists in the locale file
  const messageText = 'Artikel erfolgreich zum Warenkorb hinzugefügt';

  // Create success icon (checkmark)
  const successIcon = document.createElement('div');
  successIcon.innerHTML = `
  <svg class="icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
  `


  // Add icon and text to message
  successMessage.appendChild(successIcon);
  successMessage.appendChild(document.createTextNode(messageText));
  
  // Add to page
  document.body.appendChild(successMessage);
  
  // Trigger animation
  setTimeout(() => {
    successMessage.classList.add('show');
  }, 10);
  
  // Auto-hide after 3 seconds
  setTimeout(() => {
    successMessage.classList.remove('show');
    setTimeout(() => {
      if (successMessage.parentNode) {
        successMessage.remove();
      }
    }, 300); // Wait for transition to complete
  }, 3000);
}

// Make function globally available
window.showCartSuccessMessage = showCartSuccessMessage;
